import React from 'react';
import { Navigate, Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CategoryDetail from './pages/CategoryDetail';
import CategoryLanding from './pages/CategoryLanding';
import ItemDetail from './pages/ItemDetail';
import WhatsAppFloat from './components/WhatsAppFloat';
import { SITE_BASE_URL } from './data/productCategories';

function App() {
  const baseUrl = SITE_BASE_URL;
  const logoUrl = `${baseUrl}/trade-zone-logo.png`;
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Trade Zone Equipments",
    "url": baseUrl,
    "logo": logoUrl,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-798-046-1478",
      "contactType": "sales",
      "areaServed": "Global"
    },
    "sameAs": [
      "https://facebook.com/tradezoneequipments",
      "https://twitter.com/tradezoneequip",
      "https://linkedin.com/company/tradezoneequipments",
      "https://instagram.com/tradezoneequipments"
    ]
  };

  return (
    <Router>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Legacy product detail page — keep available for inbound SEO. */}
        <Route path="/category/planetary-gear-41a0002" element={<CategoryDetail />} />
        {/* Brand-item detail page — /category/{brand}/{slug-with-partnumber} */}
        <Route path="/category/:brandSlug/:itemSlug" element={<ItemDetail />} />
        {/* Category landing (system + brand). Keep last so it acts as the fallback. */}
        <Route path="/category/:slug" element={<CategoryLanding />} />
        {/* Final fallback — bounce unknown URLs to home so they don't 404 silently. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <WhatsAppFloat />
    </Router>
  );
}

export default App;